import React, { useState, useEffect, useRef, createRef } from 'react';
import { trackPageView } from '../utils/gtm';
import AnimatedPage from '../components/AnimatedPage';
import RegisterTwoMinuteTest from '../components/landingPage/homePage/RegisterTwoMinuteTest';
import { useSelector } from 'react-redux';
// import RegisterSection from '../components/landingPage/homePage/RegisterSection';

export const COMPONENT_REF = ['banner-title', 'life-cycle-title', 'clinet-review-title', 'how-its-work-title', 'work-block-scaling', 'key-features', 'video-section-title', "register-form-title", "not-sure", 'pricing-title', 'pricing-section']

const Register = () => {
    const refs = useRef(COMPONENT_REF.map(() => createRef()));
    const [isAnimationVisible, setIsAnimationVisible] = useState(false);
    const user = useSelector((state) => state.user);
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token && user && !location?.hash) {
            if (user && ['Member', 'User'].includes(user?.role)) {
                window.location.href = '/dashboard';
            } else if (user && user?.role == 'Advisor') {
                window.location.href = '/advisor-dashboard';
            } else if (user && user?.role == 'Investor') {
                window.location.href = '/investor-dashboard';
            }
        }
    }, [user]);

    useEffect(() => {
        // Track page view when component mounts
        trackPageView('register_page');

        const observers = refs.current.map((ref, index) =>
            new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting) {
                        setIsAnimationVisible(prev => ({ ...prev, [index]: true }));
                        // Track when each section becomes visible
                        trackPageView(`register_section_${COMPONENT_REF[index]}`);
                    }
                },
                { threshold: 0.5 }
            )
        );

        refs.current.forEach((ref, index) => {
            if (ref.current) {
                observers[index].observe(ref.current);
            }
        });

        return () => {
            refs.current.forEach((ref, index) => {
                if (ref.current) {
                    observers[index].unobserve(ref.current);
                }
            });
        };
    }, []);

    return (
        <AnimatedPage>
            <div className="lp-page">
                <RegisterTwoMinuteTest
                    registerationType='User'
                    refs={refs}
                    isAnimationVisible={isAnimationVisible}
                    registerPage={true}
                />
            </div>
        </AnimatedPage>
    );
};

export default Register;